import { render, staticRenderFns } from "./joinIndex.vue?vue&type=template&id=7c993add&scoped=true&"
import script from "./joinIndex.vue?vue&type=script&lang=js&"
export * from "./joinIndex.vue?vue&type=script&lang=js&"
import style0 from "./css/index.css?vue&type=style&index=0&id=7c993add&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c993add",
  null
  
)

export default component.exports